import $ from 'jquery';

$.onAuth(({ website }) => {
  $.subscribe({ type: 'successive', name: 'time' }, (channel, now) => {
    window.now = now;
  });
});
